/**
 * Badge Definitions
 * All available badges in the system
 */

export const BADGE_TYPES = {
  SHIFT: 'SHIFT',
  EQUIPMENT: 'EQUIPMENT',
  TEAM: 'TEAM',
  SOCIAL: 'SOCIAL',
  LEVEL: 'LEVEL'
};

export const BADGE_RARITY = {
  COMMON: 'COMMON',
  RARE: 'RARE',
  EPIC: 'EPIC',
  LEGENDARY: 'LEGENDARY'
};

export const BADGES = {
  // Shift Badges
  FIRST_SHIFT: {
    badgeId: 'FIRST_SHIFT',
    badgeType: BADGE_TYPES.SHIFT,
    name: 'First Shift',
    nameThai: 'เวรแรก',
    icon: '🎯',
    description: 'ทำเวรแรกสำเร็จ',
    requirement: {
      type: 'shifts_completed',
      value: 1
    },
    reward: {
      points: 50,
      coins: 25,
      xp: 100
    },
    rarity: BADGE_RARITY.COMMON
  },
  SHIFT_MASTER: {
    badgeId: 'SHIFT_MASTER',
    badgeType: BADGE_TYPES.SHIFT,
    name: 'Shift Master',
    nameThai: 'ผู้เชี่ยวชาญเวร',
    icon: '⭐',
    description: 'ทำเวรครบ 10 เวร',
    requirement: {
      type: 'shifts_completed',
      value: 10
    },
    reward: {
      points: 100,
      coins: 50,
      xp: 200
    },
    rarity: BADGE_RARITY.RARE
  },
  SHIFT_VETERAN: {
    badgeId: 'SHIFT_VETERAN',
    badgeType: BADGE_TYPES.SHIFT,
    name: 'Shift Veteran',
    nameThai: 'เวรอาวุโส',
    icon: '🌟',
    description: 'ทำเวรครบ 50 เวร',
    requirement: {
      type: 'shifts_completed',
      value: 50
    },
    reward: {
      points: 500,
      coins: 250,
      xp: 1000
    },
    rarity: BADGE_RARITY.EPIC
  },
  PERFECT_ATTENDANCE: {
    badgeId: 'PERFECT_ATTENDANCE',
    badgeType: BADGE_TYPES.SHIFT,
    name: 'Perfect Attendance',
    nameThai: 'มาเวรครบถ้วน',
    icon: '💯',
    description: 'มาเวรติดต่อกัน 30 วัน',
    requirement: {
      type: 'perfect_attendance_days',
      value: 30
    },
    reward: {
      points: 500,
      coins: 200,
      xp: 1000
    },
    rarity: BADGE_RARITY.EPIC
  },
  NIGHT_OWL: {
    badgeId: 'NIGHT_OWL',
    badgeType: BADGE_TYPES.SHIFT,
    name: 'Night Owl',
    nameThai: 'นกฮูก',
    icon: '🦉',
    description: 'ทำเวรดึกครบ 20 เวร',
    requirement: {
      type: 'night_shifts_completed',
      value: 20
    },
    reward: {
      points: 200,
      coins: 100,
      xp: 400
    },
    rarity: BADGE_RARITY.RARE
  },

  // Equipment Badges
  EQUIPMENT_EXPERT: {
    badgeId: 'EQUIPMENT_EXPERT',
    badgeType: BADGE_TYPES.EQUIPMENT,
    name: 'Equipment Expert',
    nameThai: 'ผู้เชี่ยวชาญอุปกรณ์',
    icon: '🔧',
    description: 'ตรวจสอบอุปกรณ์ครบ 20 ครั้ง',
    requirement: {
      type: 'inspections_completed',
      value: 20
    },
    reward: {
      points: 200,
      coins: 100,
      xp: 400
    },
    rarity: BADGE_RARITY.RARE
  },
  BORROW_MASTER: {
    badgeId: 'BORROW_MASTER',
    badgeType: BADGE_TYPES.EQUIPMENT,
    name: 'Borrow Master',
    nameThai: 'ผู้เชี่ยวชาญการยืม',
    icon: '📦',
    description: 'ยืมอุปกรณ์ครบ 50 ครั้ง',
    requirement: {
      type: 'borrows_completed',
      value: 50
    },
    reward: {
      points: 300,
      coins: 150,
      xp: 600
    },
    rarity: BADGE_RARITY.EPIC
  },
  REPAIR_MASTER: {
    badgeId: 'REPAIR_MASTER',
    badgeType: BADGE_TYPES.EQUIPMENT,
    name: 'Repair Master',
    nameThai: 'ผู้เชี่ยวชาญการซ่อม',
    icon: '🔨',
    description: 'ซ่อมอุปกรณ์เสร็จครบ 10 ครั้ง',
    requirement: {
      type: 'repairs_completed',
      value: 10
    },
    reward: {
      points: 250,
      coins: 125,
      xp: 500
    },
    rarity: BADGE_RARITY.RARE
  },
  STOCK_MASTER: {
    badgeId: 'STOCK_MASTER',
    badgeType: BADGE_TYPES.EQUIPMENT,
    name: 'Stock Master',
    nameThai: 'ผู้เชี่ยวชาญ Stock',
    icon: '📊',
    description: 'ทำ Stock In/Out ครบ 50 ครั้ง',
    requirement: {
      type: 'stock_transactions',
      value: 50
    },
    reward: {
      points: 300,
      coins: 150,
      xp: 600
    },
    rarity: BADGE_RARITY.EPIC
  },

  // Team Badges
  TEAM_PLAYER: {
    badgeId: 'TEAM_PLAYER',
    badgeType: BADGE_TYPES.TEAM,
    name: 'Team Player',
    nameThai: 'ผู้เล่นทีม',
    icon: '👥',
    description: 'เข้าร่วมทีม',
    requirement: {
      type: 'teams_joined',
      value: 1
    },
    reward: {
      points: 100,
      coins: 20,
      xp: 200
    },
    rarity: BADGE_RARITY.COMMON
  },
  TEAM_LEADER: {
    badgeId: 'TEAM_LEADER',
    badgeType: BADGE_TYPES.TEAM,
    name: 'Team Leader',
    nameThai: 'หัวหน้าทีม',
    icon: '👑',
    description: 'เป็นหัวหน้าทีม',
    requirement: {
      type: 'teams_led',
      value: 1
    },
    reward: {
      points: 200,
      coins: 50,
      xp: 400
    },
    rarity: BADGE_RARITY.RARE
  },
  TEAM_BUILDER: {
    badgeId: 'TEAM_BUILDER',
    badgeType: BADGE_TYPES.TEAM,
    name: 'Team Builder',
    nameThai: 'ผู้สร้างทีม',
    icon: '🏗️',
    description: 'สร้างทีม',
    requirement: {
      type: 'teams_created',
      value: 1
    },
    reward: {
      points: 150,
      coins: 30,
      xp: 300
    },
    rarity: BADGE_RARITY.RARE
  },

  // Social Badges
  GIFT_GIVER: {
    badgeId: 'GIFT_GIVER',
    badgeType: BADGE_TYPES.SOCIAL,
    name: 'Gift Giver',
    nameThai: 'ผู้ให้ของขวัญ',
    icon: '🎁',
    description: 'ให้ของขวัญครบ 10 ครั้ง',
    requirement: {
      type: 'gifts_given',
      value: 10
    },
    reward: {
      points: 100,
      coins: 50,
      xp: 200
    },
    rarity: BADGE_RARITY.RARE
  },
  GIFT_RECEIVER: {
    badgeId: 'GIFT_RECEIVER',
    badgeType: BADGE_TYPES.SOCIAL,
    name: 'Gift Receiver',
    nameThai: 'ผู้รับของขวัญ',
    icon: '💝',
    description: 'รับของขวัญครบ 10 ครั้ง',
    requirement: {
      type: 'gifts_received',
      value: 10
    },
    reward: {
      points: 50,
      coins: 25,
      xp: 100
    },
    rarity: BADGE_RARITY.COMMON
  },
  GENEROUS: {
    badgeId: 'GENEROUS',
    badgeType: BADGE_TYPES.SOCIAL,
    name: 'Generous',
    nameThai: 'ใจกว้าง',
    icon: '💰',
    description: 'ให้ของขวัญมูลค่ารวม 1000+ T Coins',
    requirement: {
      type: 'gifts_total_value',
      value: 1000
    },
    reward: {
      points: 200,
      coins: 100,
      xp: 400
    },
    rarity: BADGE_RARITY.EPIC
  },

  // Level Badges
  LEVEL_2: {
    badgeId: 'LEVEL_2',
    badgeType: BADGE_TYPES.LEVEL,
    name: 'Level 2',
    nameThai: 'Level 2',
    icon: '🥈',
    description: 'ถึง Level 2',
    requirement: {
      type: 'level',
      value: 2
    },
    reward: {
      points: 100,
      coins: 50,
      xp: 0
    },
    rarity: BADGE_RARITY.COMMON
  },
  LEVEL_3: {
    badgeId: 'LEVEL_3',
    badgeType: BADGE_TYPES.LEVEL,
    name: 'Level 3',
    nameThai: 'Level 3',
    icon: '🥇',
    description: 'ถึง Level 3',
    requirement: {
      type: 'level',
      value: 3
    },
    reward: {
      points: 200,
      coins: 100,
      xp: 0
    },
    rarity: BADGE_RARITY.RARE
  },
  LEVEL_4: {
    badgeId: 'LEVEL_4',
    badgeType: BADGE_TYPES.LEVEL,
    name: 'Level 4',
    nameThai: 'Level 4',
    icon: '💎',
    description: 'ถึง Level 4',
    requirement: {
      type: 'level',
      value: 4
    },
    reward: {
      points: 300,
      coins: 150,
      xp: 0
    },
    rarity: BADGE_RARITY.EPIC
  },
  LEVEL_5: {
    badgeId: 'LEVEL_5',
    badgeType: BADGE_TYPES.LEVEL,
    name: 'Level 5',
    nameThai: 'Level 5',
    icon: '👑',
    description: 'ถึง Level 5',
    requirement: {
      type: 'level',
      value: 5
    },
    reward: {
      points: 500,
      coins: 250,
      xp: 0
    },
    rarity: BADGE_RARITY.LEGENDARY
  }
};

// Get all badges as array
export const getAllBadges = () => Object.values(BADGES);

// Get badges by type
export const getBadgesByType = (badgeType) => {
  return getAllBadges().filter(badge => badge.badgeType === badgeType);
};

// Get badge by ID
export const getBadgeById = (badgeId) => {
  return BADGES[badgeId] || null;
};



